import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

function convertValues(value) {
  if (value?._isAMomentObject || value instanceof Date) {
    return new Date(value).toISOString().replace('T00:00:00.000Z', '');
  }
  return value;
}

function urlQueryParamsToObject() {
  const params = new URLSearchParams(window.location.search);
  const result: any = {};

  params.forEach((value, key) => {
    result[key] = value;
  });

  return result;
}

@Injectable()
export class UrlParamsService {
  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) { }
  set(params: any) {
    params = { ...params }

    Object.keys(params).forEach((key) => {
      params[key] = convertValues(params[key]);
    });

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: params
    });
  }

  get(key: string, defaultValue: any = null) {
    const params = urlQueryParamsToObject();

    if (!key) {
      return params;
    }

    return params[key] ?? defaultValue;
  }
}

